import { useEffect, useRef, useContext } from "react";
import CustomModal from "../CustomModal/CustomModal";
import { Link } from "@shopify/polaris";
import { AppConfigContext } from "../../context/AppConfigContext";
import { BiLinkExternal } from "react-icons/bi";
import useSnippet from "../../hooks/useSnippet";

const ActivateSnippetModal = ({
    setShowEnableCoreSnippetModal,
    onSnippetEnabled,
    appType = "bundles",
}: {
    setShowEnableCoreSnippetModal: (val: boolean) => void;
    onSnippetEnabled: () => void;
    appType?: string;
}) => {
    const appConfigContext = useContext(AppConfigContext);
    const { isEnabled } = useSnippet();

    const hasAutoActivated = useRef(false);

    const extensionUrl = `https://admin.shopify.com/store/${appConfigContext.shop}/themes/current/editor?context=apps&activateAppId=${appConfigContext.extensionId}%2Fkefi`;

    useEffect(() => {
        if (isEnabled === 1 && !hasAutoActivated.current) {
            hasAutoActivated.current = true;

            setShowEnableCoreSnippetModal(false);
            onSnippetEnabled();
        }
    }, [isEnabled, onSnippetEnabled, setShowEnableCoreSnippetModal]);

    if (isEnabled !== 0) return null;

    return (
        <CustomModal
            noScroll
            open
            title={`Enable Kefi Core Snippet to see ${appType} on your shop`}
            onClose={() => setShowEnableCoreSnippetModal(false)}
            noClose
            primaryAction={{
                // @ts-expect-error required
                content: (
                    <Link monochrome removeUnderline url={extensionUrl} target="_blank">
                        <BiLinkExternal size="16px" style={{ marginBottom: "-3px" }} />
                        &nbsp; Enable Core Snippet
                    </Link>
                ),
                plain: true,
            }}
        >
            <div
                style={{
                    height: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                }}
            >
                <img width="100%" style={{ objectFit: "cover" }} src="/onboarding.gif" />
            </div>
        </CustomModal>
    );
};

export default ActivateSnippetModal;
